import { RESET_PASSWORD_PATH } from "@/modules/auth/pages/reset-password";
import { generatePath, Navigate } from "react-router-dom";

export function OpenUserResetPasswordCode() {
  const url = new URL(window.location.href);

  return (
    <Navigate
      to={generatePath(RESET_PASSWORD_PATH, {
        code: url.searchParams.get("code"),
      })}
    />
  );
}
